import {createContext, useContext, useEffect, useMemo, useState} from "react";
import { getAuth2, signIn, signOut } from "../../features/auth/auth.service";
import { ISignInRequest } from "../../models/SignInRequest";
import { User } from "../../models/User";
import { getUser } from "../../features/users/user.service";
import { useNavigate } from "react-router-dom";

const signInHistoryKey = "sign-in-history";
const favouritesReminderKey = "favourites-reminder";

interface ILoginRequest {
  data: ISignInRequest;
  setError: (val: any) => void;
  setLoading: (val: boolean) => void;
}

const authContext = createContext({
  login: (props: ILoginRequest) => {},
  logout: () => {},
  authenticated: true,
  checkAuthenticated: () => {},
  user: { username: "", email: "" } as User | undefined,
  showSignInPrompt: false,
  clearSignInPrompt: () => {},
  favouritesReminder: "false",
  clearFavouritesReminder: () => {},
});

export const AuthProvider = ({ children }: any) => {
  const auth = useAuthProvider();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

export const useAuth = () => {
  return useContext(authContext);
};

const useAuthProvider = () => {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [signInHistory, setSignInHistory] = useState<string>(
    localStorage.getItem(signInHistoryKey) || "false",
  );
  const [showSignInPrompt, setShowSignInPrompt] = useState<boolean>(false);
    const [favouritesReminder, setFavouritesReminder] = useState<string>(
      localStorage.getItem(favouritesReminderKey) || "false",
    );
    const [user, setUser] = useState<User>();

  const navigate = useNavigate();



  useEffect(() => {
    authenticated && getUser().subscribe((res) => setUser(res));
  }, [authenticated]);

  function login({ data, setError, setLoading }: ILoginRequest) {
    signIn(data, setError, setLoading).subscribe((res) => {
      isAuthenticated();
      setLoading(false);
      navigate("/");
      setSignInHistory("true");
      localStorage.setItem(signInHistoryKey, "true");
      setFavouritesReminder("true");
      localStorage.setItem(favouritesReminderKey, "true");
    });
  }

  const logout = () => {
    signOut().subscribe((res) => {
      isAuthenticated();
      window.location.reload();
    });
  };

  const isAuthenticated = useMemo(() => () => {
    return getAuth2().subscribe({
      next: (res) => {
        setAuthenticated(res.status === 200);
      },
      error: (error) => {
        setAuthenticated(false);
        signInHistory === "true" && setShowSignInPrompt(true);
      },
    });
  },[signInHistory]);

  useEffect(() => {
    isAuthenticated();
  },[isAuthenticated]);

  const checkAuthenticated = () => {
    isAuthenticated();
  };

  const clearSignInPrompt = () => {
    localStorage.setItem(signInHistoryKey, "false");
    setSignInHistory("false");
    setShowSignInPrompt(false);
  };

    const clearFavouritesReminder = () => {
      localStorage.setItem(favouritesReminderKey, "false");
      setFavouritesReminder("false");
    };

    return {
      login,
      logout,
      authenticated,
      checkAuthenticated,
      user,
      showSignInPrompt,
      clearSignInPrompt,
      favouritesReminder,
      clearFavouritesReminder,
    };
};
